// File: frontend/src/config/pricing.js

export const PRICING_TIERS = {
  free: {
    id: 'free',
    name: 'Free Forever',
    tier_name: 'basic_wallet',
    tagline: 'Perfect for getting started',
    price: {
      monthly: 0,
      yearly: 0
    },
    features: {
      landing: [
        'Unlimited policy storage',
        '5 AI questions per month',
        'Renewal alerts (90/60/30 days)',
        'Mobile app access'
      ],
      full: [
        'Unlimited policy storage',
        '5 AI questions per month',
        '90/60/30-day renewal alerts',
        'Basic policy insights',
        'Mobile app access',
        'Email support'
      ]
    }
  },
  smart: {
    id: 'smart',
    name: 'Smart Shopper',
    tier_name: 'smart_shopper',
    tagline: 'Most popular for individuals',
    price: {
      monthly: 9.99,
      yearly: 99.99
    },
    features: {
      landing: [
        'Everything in Free',
        'Unlimited AI questions',
        'Coverage health score',
        'Rate comparison alerts'
      ],
      full: [
        'Everything in Free',
        'Unlimited AI questions',
        'Coverage health score',
        'Share with 2 users',
        'Priority email support',
        'Rate comparison alerts',
        'Gap detection'
      ]
    }
  },
  complete: {
    id: 'complete',
    name: 'Complete Protection',
    tier_name: 'complete_protection',
    tagline: 'Best for families',
    price: {
      monthly: 24.99,
      yearly: 249.99
    },
    features: {
      landing: [
        'Everything in Smart',
        'AI Claims filing assistant',
        'Share with 4 users',
        'Priority phone support'
      ],
      full: [
        'Everything in Smart',
        'AI Claims filing assistant',
        'Quarterly rate comparison',
        'Share with 4 users',
        'Priority phone support',
        'Document vault (5GB)',
        'Custom alerts'
      ]
    }
  },
  business: {
    id: 'business',
    name: 'Business Shield',
    tier_name: 'business_shield',
    tagline: 'For small businesses',
    price: {
      monthly: 49.99,
      yearly: 499.99
    },
    features: {
      landing: [
        'Everything in Complete',
        'AI Risk Manager',
        'Share with 10 users',
        'Dedicated account manager'
      ],
      full: [
        'Everything in Complete',
        'AI Risk Manager',
        'Share with 10 users',
        'Dedicated account manager',
        'Custom integrations',
        'Document vault (25GB)',
        'API access',
        'White-label options'
      ]
    }
  }
};

export const LANDING_TIERS = ['free', 'smart', 'complete'];
export const ALL_TIERS = ['free', 'smart', 'complete', 'business'];